import { makeStyles } from '@material-ui/core';


const useStyles = makeStyles(theme => ({
  container: {
    background: theme.palette.background.paper,
    border: `1px solid ${theme.palette.border}`,
    borderRadius: '4px',
    padding: '8px',
    margin: 0,
  },
}));

export default useStyles;
